import { useParams } from 'react-router-dom';
import { OrderDetailContainer } from '@/features/orders/containers/order-detail-container';

export default function OrderDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return <OrderDetailContainer orderId={id} />;
}
